var installedModules = {};
var moduleToHandlerMapping = {
	341: {
		getter: () => (Promise.all([__webpack_require__.e(6902), __webpack_require__.e(4199), __webpack_require__.e(784), __webpack_require__.e(6153)]).then(() => (() => (__webpack_require__(12503))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@bs/assets",
	},
	3002: {
		getter: () => (__webpack_require__.e(8092).then(() => (() => (__webpack_require__(45711))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^9.1.3",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-toastify",
	},
	3656: {
		getter: () => (__webpack_require__.e(9929).then(() => (() => (__webpack_require__(79929))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.0.7",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "check-password-strength",
	},
	6009: {
		getter: () => (__webpack_require__.e(6528).then(() => (() => (__webpack_require__(54147))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@bs/hooks",
	},
	6273: {
		getter: () => (__webpack_require__.e(2042).then(() => (() => (__webpack_require__(19661))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@bs/api",
	},
	8903: {
		getter: () => (Promise.all([__webpack_require__.e(4276), __webpack_require__.e(6441), __webpack_require__.e(1206), __webpack_require__.e(5730)]).then(() => (() => (__webpack_require__(21206))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^9.2.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "reactstrap",
	},
	9151: {
		getter: () => (Promise.all([__webpack_require__.e(9776), __webpack_require__.e(5156)]).then(() => (() => (__webpack_require__(89776))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "crypto-js",
	},
	9892: {
		getter: () => (__webpack_require__.e(1091).then(() => (() => (__webpack_require__(63472))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "9.8.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-intersection-observer",
	},
	12153: {
		getter: () => (__webpack_require__.e(9808).then(() => (() => (__webpack_require__(89808))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.3.6",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-components",
	},
	13349: {
		getter: () => (__webpack_require__.e(8485).then(() => (() => (__webpack_require__(28485))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.3.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	18077: {
		getter: () => (__webpack_require__.e(6520).then(() => (() => (__webpack_require__(16520))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.15.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-phone-input-2",
	},
	19314: {
		getter: () => (Promise.all([__webpack_require__.e(6902), __webpack_require__.e(7833), __webpack_require__.e(7635)]).then(() => (() => (__webpack_require__(7833))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.8.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-select",
	},
	20328: {
		getter: () => (__webpack_require__.e(2812).then(() => (() => (__webpack_require__(72812))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.5.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "object-to-formdata",
	},
	20880: {
		getter: () => (__webpack_require__.e(7739).then(() => (() => (__webpack_require__(7739))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.2.2",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-portal",
	},
	24337: {
		getter: () => (Promise.all([__webpack_require__.e(6441), __webpack_require__.e(1390), __webpack_require__.e(16)]).then(() => (() => (__webpack_require__(81390))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.25.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-datepicker",
	},
	26587: {
		getter: () => (__webpack_require__.e(7552).then(() => (() => (__webpack_require__(7552))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.3.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	30004: {
		getter: () => (__webpack_require__.e(4867).then(() => (() => (__webpack_require__(44867))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^7.0.6",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@json2csv/plainjs",
	},
	31227: {
		getter: () => (__webpack_require__.e(3672).then(() => (() => (__webpack_require__(43672))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.11.5",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "libphonenumber-js",
	},
	33861: {
		getter: () => (Promise.all([__webpack_require__.e(2043), __webpack_require__.e(2852)]).then(() => (() => (__webpack_require__(72852))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "6.11.2",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	},
	34049: {
		getter: () => (__webpack_require__.e(9491).then(() => (() => (__webpack_require__(81872))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^8.2.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-paginate",
	},
	37865: {
		getter: () => (__webpack_require__.e(6499).then(() => (() => (__webpack_require__(58880))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.1.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-otp-input",
	},
	40069: {
		getter: () => (__webpack_require__.e(9775).then(() => (() => (__webpack_require__(52156))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.3.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-loading-skeleton",
	},
	41579: {
		getter: () => (__webpack_require__.e(4166).then(() => (() => (__webpack_require__(84166))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.19.3",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-color",
	},
	41699: {
		getter: () => (Promise.all([__webpack_require__.e(6967), __webpack_require__.e(6857)]).then(() => (() => (__webpack_require__(73681))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.30.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "moment",
	},
	41995: {
		getter: () => (__webpack_require__.e(2400).then(() => (() => (__webpack_require__(70019))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.7.2",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-idle-timer",
	},
	46691: {
		getter: () => (__webpack_require__.e(9316).then(() => (() => (__webpack_require__(79316))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.0.37",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "ua-parser-js",
	},
	51865: {
		getter: () => (Promise.all([__webpack_require__.e(4276), __webpack_require__.e(1050), __webpack_require__.e(3442), __webpack_require__.e(8111)]).then(() => (() => (__webpack_require__(93442))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.10.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-bootstrap",
	},
	52133: {
		getter: () => (__webpack_require__.e(3314).then(() => (() => (__webpack_require__(53314))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^9.0.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "uuid",
	},
	57828: {
		getter: () => (Promise.all([__webpack_require__.e(4276), __webpack_require__.e(6263), __webpack_require__.e(492)]).then(() => (() => (__webpack_require__(66263))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.12.4",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@material-ui/core",
	},
	58667: {
		getter: () => (Promise.all([__webpack_require__.e(5974), __webpack_require__.e(7847), __webpack_require__.e(8955)]).then(() => (() => (__webpack_require__(11336))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@bs/utils",
	},
	61357: {
		getter: () => (__webpack_require__.e(8131).then(() => (() => (__webpack_require__(68131))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "14.3.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dropzone",
	},
	65782: {
		getter: () => (__webpack_require__.e(3478).then(() => (() => (__webpack_require__(3478))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.0.5",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "js-cookie",
	},
	65870: {
		getter: () => (Promise.all([__webpack_require__.e(426), __webpack_require__.e(3349)]).then(() => (() => (__webpack_require__(10426))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.39.3",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-query",
	},
	72922: {
		getter: () => (__webpack_require__.e(5772).then(() => (() => (__webpack_require__(5772))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^9.1.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-pdf",
	},
	73368: {
		getter: () => (__webpack_require__.e(2027).then(() => (() => (__webpack_require__(42027))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.5.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-custom-scrollbars-2",
	},
	74832: {
		getter: () => (__webpack_require__.e(8180).then(() => (() => (__webpack_require__(48180))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.3.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom/server",
	},
	75137: {
		getter: () => (Promise.all([__webpack_require__.e(1050), __webpack_require__.e(4392)]).then(() => (() => (__webpack_require__(34392))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.11.8",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@popperjs/core",
	},
	75461: {
		getter: () => (__webpack_require__.e(8667).then(() => (() => (__webpack_require__(78667))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.17.21",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "lodash",
	},
	77225: {
		getter: () => (Promise.all([__webpack_require__.e(4276), __webpack_require__.e(6902), __webpack_require__.e(4199), __webpack_require__.e(4267), __webpack_require__.e(2060), __webpack_require__.e(5254)]).then(() => (() => (__webpack_require__(12060))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.0.0-alpha.161",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@mui/lab",
	},
	79120: {
		getter: () => (__webpack_require__.e(1894).then(() => (() => (__webpack_require__(81894))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.1.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-helmet",
	},
	80704: {
		getter: () => (__webpack_require__.e(6676).then(() => (() => (__webpack_require__(86676))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.0.2",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "echarts-for-react",
	},
	81101: {
		getter: () => (() => (__webpack_require__(24546))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.0.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@bs/common-ui",
	},
	82923: {
		getter: () => (__webpack_require__.e(5058).then(() => (() => (__webpack_require__(12677))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.1.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-image",
	},
	87338: {
		getter: () => (Promise.all([__webpack_require__.e(4276), __webpack_require__.e(6902), __webpack_require__.e(4199), __webpack_require__.e(4267), __webpack_require__.e(4575), __webpack_require__.e(2873)]).then(() => (() => (__webpack_require__(74575))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.15.4",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@mui/material",
	},
	89373: {
		getter: () => (__webpack_require__.e(8144).then(() => (() => (__webpack_require__(48144))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.7.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "jquery",
	},
	97672: {
		getter: () => (__webpack_require__.e(7559).then(() => (() => (__webpack_require__(7559))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^8.12.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@tanstack/react-table",
	},
	97867: {
		getter: () => (__webpack_require__.e(6715).then(() => (() => (__webpack_require__(6715))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.2.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "country-state-city",
	},
	11892: {
		getter: () => (__webpack_require__.e(6963).then(() => (() => (__webpack_require__(6963))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.7.7",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "axios",
	},
	90092: {
		getter: () => (__webpack_require__.e(8953).then(() => (() => (__webpack_require__(78953))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.4.8",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-image-file-resizer",
	},
	64152: {
		getter: () => (__webpack_require__.e(5301).then(() => (() => (__webpack_require__(45301))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.5.2",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "jspdf",
	},
	10761: {
		getter: () => (__webpack_require__.e(9694).then(() => (() => (__webpack_require__(9694))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.4.1",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "html2canvas",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"16": [
		13349
	],
	"19": [
		26587
	],
	"120": [
		13349,
		26587
	],
	"202": [
		13349,
		26587
	],
	"492": [
		13349
	],
	"761": [
		10761
	],
	"1336": [
		341,
		3002,
		9151,
		20328,
		26587,
		30004,
		31227,
		33861,
		41699,
		46691,
		52133,
		65782,
		75461,
		97867
	],
	"1825": [
		26587
	],
	"1872": [
		26587
	],
	"2042": [
		11892,
		65782,
		75461
	],
	"2156": [
		26587
	],
	"2301": [
		26587
	],
	"2677": [
		26587
	],
	"2873": [
		13349
	],
	"3349": [
		13349
	],
	"3472": [
		26587
	],
	"3727": [
		13349,
		26587,
		75137
	],
	"4087": [
		13349,
		26587,
		75137
	],
	"4147": [
		6273,
		26587,
		33861,
		41699,
		58667,
		65870,
		90092
	],
	"4152": [
		64152
	],
	"4206": [
		26587
	],
	"4546": [
		341,
		3656,
		6009,
		6273,
		8903,
		9892,
		12153,
		18077,
		19314,
		20880,
		24337,
		26587,
		33861,
		34049,
		37865,
		40069,
		41579,
		41699,
		41995,
		51865,
		57828,
		58667,
		61357,
		65870,
		72922,
		73368,
		74832,
		75137,
		75461,
		77225,
		79120,
		80704,
		82923,
		87338,
		89373,
		97672,
		97867
	],
	"4682": [
		26587
	],
	"5137": [
		75137
	],
	"5254": [
		13349
	],
	"5635": [
		26587
	],
	"5711": [
		26587
	],
	"5730": [
		13349
	],
	"5882": [
		13349,
		26587,
		75137
	],
	"6108": [
		13349,
		26587,
		75137
	],
	"6153": [
		12153
	],
	"6528": [
		90092
	],
	"6587": [
		26587
	],
	"7031": [
		13349,
		26587
	],
	"7063": [
		26587
	],
	"7626": [
		26587
	],
	"7635": [
		13349
	],
	"7739": [
		13349
	],
	"7821": [
		13349,
		26587
	],
	"8016": [
		26587
	],
	"8111": [
		13349
	],
	"8534": [
		12153,
		26587,
		75461
	],
	"8880": [
		26587
	],
	"8955": [
		341,
		3002,
		9151,
		20328,
		30004,
		31227,
		46691,
		52133,
		65782,
		75461,
		97867
	],
	"8968": [
		26587
	],
	"9121": [
		341,
		3002,
		3656,
		6009,
		6273,
		8903,
		9151,
		9892,
		12153,
		13349,
		18077,
		19314,
		20328,
		20880,
		24337,
		26587,
		30004,
		31227,
		33861,
		34049,
		37865,
		40069,
		41579,
		41699,
		41995,
		46691,
		51865,
		52133,
		57828,
		58667,
		61357,
		65782,
		65870,
		72922,
		73368,
		74832,
		75137,
		75461,
		77225,
		79120,
		80704,
		81101,
		82923,
		87338,
		89373,
		97672,
		97867
	],
	"9256": [
		26587
	],
	"9367": [
		13349,
		26587
	],
	"9444": [
		26587
	],
	"9661": [
		11892,
		26587,
		33861,
		41699,
		58667,
		65782,
		65870,
		75461
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}